var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form',{ref:"ruleForm",staticClass:"demo-ruleForm",attrs:{"label-width":"140px"}},[_c('el-form-item',{staticClass:"pageSelect",attrs:{"label":"帖子Id：","prop":"page","require":""}},[_c('span',[_vm._v(_vm._s(_vm.postIdInfo.post_id))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }